import { scan } from "react-scan"; // must be imported before React and React DOM
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { BrowserRouter } from "react-router";
import "highlight.js/styles/nord.css";
import { disableBrowserZoom } from "./utils/disableBrowserZoom";

scan({
  enabled: import.meta.env.VITE_SCAN === "true",
});

// Disable browser zoom to prevent conflicts with canvas zoom
disableBrowserZoom();

createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);
